import { render, staticRenderFns } from "./GroupBooking.vue?vue&type=template&id=e8f9ef2a&scoped=true&"
import script from "./GroupBooking.vue?vue&type=script&lang=js&"
export * from "./GroupBooking.vue?vue&type=script&lang=js&"
import style0 from "./GroupBooking.vue?vue&type=style&index=0&id=e8f9ef2a&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f9ef2a",
  null
  
)

export default component.exports